// Unmount/navigation mid-request (or a newer call superseding this one) aborts a lazy
// query/refetch in Apollo v4 - not a real failure, so swallow it. Any other error is rethrown
// unchanged, leaving existing handling/propagation for real errors untouched.
const rethrowIfNotAborted = (error: Error) => {
  if (error?.name !== "AbortError") {
    throw error;
  }
};

export default rethrowIfNotAborted;
